import { useEffect, useRef, useState } from 'react';
import { Image, Palette, Gift, ScanLine, Pause, Play, ArrowRight } from 'lucide-react';
import { LoyaltyPass } from './LoyaltyPass';

const details = [
  {key:'brand',label:'Marca',icon:Image,title:'Reconhecível antes de ler o nome.',copy:'Seu logo e suas imagens. O cartão continua a experiência que começa no seu negócio.'},
  {key:'colors',label:'Cores',icon:Palette,title:'As cores são suas.',copy:'Da primeira impressão ao fundo do cartão. Escolha uma combinação que seu cliente reconhece.'},
  {key:'reward',label:'Recompensa',icon:Gift,title:'Um motivo concreto para voltar.',copy:'Você define o benefício. O cliente vê no cartão o que está mais perto de conquistar.'},
  {key:'visits',label:'Visitas',icon:ScanLine,title:'Cada visita faz parte da história.',copy:'Acompanhe os carimbos e o progresso. A equipe registra a visita e o cartão reflete o novo saldo.'},
];

export function CardAnatomy() {
  const [selected,setSelected] = useState(0);
  const [playing,setPlaying] = useState(() => !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
  const [visible,setVisible] = useState(false);
  const section = useRef<HTMLElement>(null);
  useEffect(() => {
    if (typeof IntersectionObserver !== 'function') return;
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting),{threshold:.25});
    if (section.current) observer.observe(section.current);
    return () => observer.disconnect();
  },[]);
  useEffect(() => {
    if (!playing || !visible) return;
    const timer = window.setInterval(() => {
      if (!document.hidden && !section.current?.contains(document.activeElement)) setSelected(value => (value + 1) % details.length);
    },3000);
    return () => window.clearInterval(timer);
  },[playing,visible]);
  function choose(index:number) {setSelected(index);setPlaying(false);}
  const detail = details[selected];
  return <section className="anatomy-section" id="personalizar" ref={section} aria-labelledby="anatomy-title">
    <div className="anatomy-heading"><h2 id="anatomy-title">Por fora, sua marca.<br /><span>Por dentro, seus motivos.</span></h2><p>Um cartão que parece seu. Porque é.</p></div>
    <div className="anatomy-layout">
      <div className="anatomy-stage" role="group" aria-label="Demonstração do cartão personalizável" data-detail={detail.key}>
        <span className="anatomy-callout anatomy-callout--top">Sua identidade <ArrowRight size={15}/></span>
        <div className="anatomy-pass"><LoyaltyPass name="Café Aurora" reward={selected >= 2 ? 'Um café e um doce por nossa conta' : 'Um café por nossa conta'} current={selected === 3 ? 6 : 3} background={selected === 1 ? '#3049b8' : '#214d3e'} photo="/images/neighborhood-coffee.avif" /></div>
        <span className="anatomy-callout anatomy-callout--bottom"><ScanLine size={17}/> Acesso pelo QR</span>
        <div className="anatomy-swatches" aria-hidden="true"><i/><i/><i/></div>
      </div>
      <div className="anatomy-controls">
        <div role="tablist" aria-label="Partes do cartão" onKeyDown={event => {
          if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? 3 : (selected + (event.key === 'ArrowDown' ? 1 : -1) + 4) % 4;
          choose(next);event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="tab"]')[next]?.focus();
        }} aria-orientation="vertical">
          {details.map((item,index) => <button key={item.key} role="tab" id={`anatomy-${item.key}`} aria-controls="anatomy-description" aria-selected={selected === index} tabIndex={selected === index ? 0 : -1} onClick={() => choose(index)}><item.icon size={21}/><span>{item.label}</span><ArrowRight size={17}/></button>)}
        </div>
        <div role="tabpanel" id="anatomy-description" aria-labelledby={`anatomy-${detail.key}`}><h3>{detail.title}</h3><p>{detail.copy}</p></div>
        <button className="anatomy-play" onClick={() => setPlaying(value => !value)} aria-label={playing ? 'Pausar demonstração' : 'Reproduzir demonstração'}>{playing ? <Pause size={15}/> : <Play size={15}/>}<span>{playing ? 'Pausar' : 'Reproduzir'}</span></button>
        <small>Demonstração visual. Nenhuma alteração é salva.</small>
      </div>
    </div>
  </section>;
}
